import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import { isMobile } from 'mobile-device-detect';

export default class Sounds {
  constructor(scene, camera) {
    this.scene = scene;
    this.camera = camera;

    const listener = new THREE.AudioListener();
    camera.add(listener); // Usually attach to the camera
    this.audioContext = listener.context;
    this.audioContext2 = new (
      window.AudioContext || window.webkitAudioContext
    )();

    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible') {
        if (this.audioContext2.state === 'suspended' && isMobile) {
          try {
            alert('Continue Game');
            await this.audioContext2.resume();

            console.log('Audio resumed after tab became visible.');
          } catch (err) {
            console.warn(
              'Resume failed on visibilitychange (needs gesture):',
              err
            );
          }
        }
      }
    });
    // window.addEventListener('focus', () => {
    //   this.audioContext.resume().catch((err) => {
    //     console.warn('AudioContext resume failed', err);
    //   });
    // });

    // document
    //   .querySelector('.continue_scr #continueGameBtn')
    //   .addEventListener('click', () => {
    //     this.audioContext2.resume().then(() => {});
    //     document.querySelector('.continue_scr').classList.remove('active');
    //     document.querySelector('.continue_scr').classList.remove('active2');
    //   });
  }
  isIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('SOUND_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'init_sounds':
        this.createSounds();
        break;
      case 'play_sound':
        this.playSound(data['message']['data']);
        break;
      case 'stop_sound':
        this.fadeOut(data['message']['data']);
        break;
    }
  }
  playSound(data) {
    this[`${data['sndKey']}TI`] && clearInterval(this[`${data['sndKey']}TI`]);

    if (!Global.soundEnabled) return false;

    if (!this[`${data['sndKey']}Snd`].getLoop() && Global.soundEnabled) {
      if (!this[`${data['sndKey']}Snd`].isPlaying || data['sndKey'] !== 'hit') {
        this[`${data['sndKey']}Snd`].stop();
        this[`${data['sndKey']}Snd`].setVolume(0.5);
        this[`${data['sndKey']}Snd`].play();
      }
    }
    if (
      !this[`${data['sndKey']}Snd`].isPlaying &&
      this[`${data['sndKey']}Snd`].getLoop()
    ) {
      this[`${data['sndKey']}Snd`].setVolume(0.5);
      this[`${data['sndKey']}Snd`].play();
      this.BGSOund = this[`${data['sndKey']}Snd`];
    }
  }
  fadeOut(data) {
    this[`${data['sndKey']}Snd`].stop();
    // this[`${data['sndKey']}TI`] = setInterval(
    //   function (data) {
    //     var volume = this[`${data['sndKey']}Snd`].getVolume();
    //     if (volume > 0) {
    //       volume -= 0.03; // Adjust this value for the fadeout speed
    //       this[`${data['sndKey']}Snd`].setVolume(volume);
    //     } else {
    //       this[`${data['sndKey']}Snd`].stop();
    //       clearInterval(this[`${data['sndKey']}TI`]);
    //     }
    //   }.bind(this, data),
    //   10
    // ); // Adjust this value for smoother or faster fadeout
  }
  createSounds() {
    this.listener = new THREE.AudioListener();
    this.camera.add(this.listener);

    this.headSnd = new THREE.Audio(this.listener);
    this.headSnd.setBuffer(Global.assets['sounds']['head']['asset']);
    this.headSnd.setLoop(false); // Set whether the audio should loop
    this.headSnd.setVolume(0.5); // Set the volume (0 to 1)

    this.clickSnd = new THREE.Audio(this.listener);
    this.clickSnd.setBuffer(Global.assets['sounds']['click']['asset']);
    this.clickSnd.setLoop(false); // Set whether the audio should loop
    this.clickSnd.setVolume(0.5); // Set the volume (0 to 1)
  }
}
